import { useParams } from 'react-router-dom'
import * as React from 'react'
import { createContext, useContext, useEffect, useState } from 'react'
import { UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'
import { tsStudy } from '../../../Typescript/StuartPy/Study'
import { usePyGet } from '../../../APIs/Hooks/PyAPIHooks'

interface StudyContextInterface {
  studyQuery: UseQueryResult<tsStudy, AxiosResponse<any, any>>
  studyEdit: tsStudy
  setStudyEdit: any
}

const StudyContext = createContext<StudyContextInterface>(
  {} as StudyContextInterface,
)
export const useStudyContext = () => useContext(StudyContext)

function SelectedStudyModule({ children }: { children: any }) {
  const { study_id } = useParams()
  const studyQuery = usePyGet(['/study', `/${study_id}`], !!study_id)
  const [studyEdit, setStudyEdit] = useState({} as tsStudy)

  useEffect(() => {
    if (studyQuery.data) {
      setStudyEdit(studyQuery.data)
    }
  }, [studyQuery.data])
  return (
    <StudyContext.Provider
      value={{
        studyQuery,
        studyEdit,
        setStudyEdit,
      }}
    >
      {children}
    </StudyContext.Provider>
  )
}

export default SelectedStudyModule
